export default {
    name: 'GeneralDetails',

    props: {
        operation: {
            type: Object,
            required: true
        }
    },

    methods: {
        /**
         * Get refund tipe
         * @return {Number} amount
         */
        getRefundType() {
            if (this.operation.amount_shares_indicator === 'B') {
                return 'Por importe bruto';
            } else if (this.operation.amount_shares_indicator === 'P') {
                return 'Por participaciones';
            } else {
                return 'Total';
            }
        }
    },
    computed: {
        getGrossAmount() {
            if (this.operation.is_total_transfer) {
                return 'Traspaso Total';
            }
            return this.operation.gross_amount > 0 ? this.operation.gross_amount : this.operation.net_amount;
        },
        paymentStatusLabel() {
            switch (this.operation.payment_status) {
            case 'PAGO_COMPLETADO':
                return 'Pagado';
            case 'PAGO_ERRONEO':
                return 'Fallido';
            default:
                return 'Pendiente';
            }
        }
    }
};
